<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.unidadeExecutanteManutencao"
        ref="RkmDataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{item}">
            <rkm-button
                @click="edit(item.id)"
                authorize="update-cadastro-unidade-executante-manutencao"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                v-if="!item.allowDestroy"
                @click="destroy(item)"
                authorize="destroy-cadastro-unidade-executante-manutencao"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>

            <rkm-button
                v-else-if="item.allowDisable && item.allowDestroy"
                @click="toggleStatus(item)"
                authorize="update-cadastro-unidade-executante-manutencao"
                color="warning"
                small
                title="Desativar"
            >
                <rkm-icon icon="times-circle" />
            </rkm-button>

            <rkm-button
                v-else-if="!item.allowDisable && item.allowDestroy"
                @click="toggleStatus(item)"
                authorize="update-cadastro-unidade-executante-manutencao"
                color="success"
                small
                title="Ativar"
            >
                <rkm-icon icon="check-circle" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>

// Mixins.
import {error, formats, repository, stringCase} from '@/mixins'

export default {
    created() {
        this.repositories = {

            unidadeExecutanteManutencao: this.getConectaSusRepository('cadastro.unidadeExecutanteManutencao'),
        }
    },
    data: () => ({
        fields: [
            {key: 'nome', label: 'Unidade', name: 'nome', searchable: true, sortable: true},
            {key: 'usuarioNome', label: 'Profissional Executante', name: 'usuarioNome', searchable: true, sortable: true},
            {key: 'isPrestador', label: 'Tipo', name: 'isPrestador', searchable: true, sortable: true},
            {key: 'telefone', label: 'Telefone', name: 'telefone', searchable: true, sortable: true},
            {class: 'col-min', key: 'actions', label: 'Ações', name: 'actions'},
        ],
    }),
    methods: {
        edit(id) {

            this.$router.push({name: 'cadastro-unidade-executante-manutencao-edit', params: {id}})
        },
        destroy(item) {
            const destroy = () => this.repositories.unidadeExecutanteManutencao.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir a unidade?', destroy)
        },
        toggleStatus(item) {

            const newStatus = !item.status;

            const payload = {
                unidadePrestadorId: this.prepareData(item.unidadePrestadorId),
                status: newStatus,
            }

            this.repositories.unidadeExecutanteManutencao.update(item.id, payload)
                .then(() => this.$refs.RkmDataTable.refresh())
        },
        prepareData(data) {

            return this.camelObjectKeysToSnakeRecursive(data);
        },
    },
    mixins: [error, formats, repository, stringCase],
}
</script>